import { http, HttpResponse, delay } from 'msw';

import { simpleEmployee } from '@/mocks/data/employeeData';
import {
  simpleCallerIdentity,
  simpleUser,
  simpleUserIdentities,
} from '@/mocks/data/userData';

export const userHandlers = [
  http.get('*/v1/users/me', async () => {
    await delay();
    return HttpResponse.json(simpleCallerIdentity, { status: 200 });
  }),
  http.get('*/v1/users/me/identities', async () => {
    await delay();
    return HttpResponse.json(simpleUserIdentities, { status: 200 });
  }),
  http.patch('*/v1/users/me/language', async () => {
    await delay();
    return HttpResponse.json(simpleUser, { status: 200 });
  }),
  http.get('*/v2/users/:userId', async () => {
    await delay();
    return HttpResponse.json(simpleUser, { status: 200 });
  }),
  http.post('*/v1/users/:email/resend-verification-email', async () => {
    await delay();
    return new HttpResponse(null, { status: 200 });
  }),
  http.get(
    '*/v1/organizations/:organizationId/users/:userId/employee',
    async () => {
      await delay();
      return HttpResponse.json(simpleEmployee, { status: 200 });
    }
  ),
];
